"use strict";

import React, { Component, PropTypes } from 'react';
import { Modal, Button } from 'react-bootstrap';

import QuestionActions from '../../../actions/QuestionActions';
import QuestionStore from '../../../stores/QuestionStore';
import QuestionPopupForm from './QuestionForm';

class QuestionPopup extends Component {

  constructor() {
    super();
    this.state = {
      canSubmit: false
    };

    this._onFormValid = this._onFormValid.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleQuestionStore = this._handleQuestionStore.bind(this);
  };

  static propTypes = {
    open: PropTypes.bool.isRequired
  };

  componentWillMount() {
    QuestionStore.listen(this._handleQuestionStore);
  };

  componentWillUnmount() {
    QuestionStore.unlisten(this._handleQuestionStore);
  };

  render() {
    return(
      <Modal show={this.props.open} onHide={QuestionPopup._handleCloseQuestionPopup}>
        <Modal.Header closeButton>
          <Modal.Title>Ask a Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <QuestionPopupForm ref={ form => this.quesForm = form }
                             isValid={this._onFormValid}
                             editQuestionPopup={this.state.editQuestionPopup} />
                             <div>
          <Button bsStyle="success"
                  disabled={!this.state.canSubmit}
                  onClick={this._handleSubmit} >Submit</Button>
          <Button className="m-l-5p" type="button"
                  bsStyle="default"
                  onClick={QuestionPopup._handleCloseQuestionPopup}>Cancel</Button>
                             </div>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  };

  _onFormValid(isValid) {
    this.setState({ canSubmit: isValid });
  };

  _handleSubmit(e) {
    e.preventDefault();

    let question = this.quesForm.getModel();
    const _id = question._id;

    delete question._id;
    const  location = window.location.pathname;
    let qType = "", idx=0;

    if(location.indexOf('question-feed') > -1){
      qType=JSON.stringify({"qFeed":1});
    } else if(location.indexOf('question/') > -1){
      idx = location.indexOf('question/');
      let qId = location.substring(idx+9);
      qId = (qId.indexOf('/')>-1 ? qId.substring(qId.indexOf('/')+1) : qId);
      qType = JSON.stringify({"qId":qId})
    } else if(location.indexOf('q/') > -1){
      idx = location.indexOf('q/');
      let cId = location.substring(idx+13);
      cId = (cId.indexOf('/')>-1 ? cId.substring(cId.indexOf('/')+1) : cId);
      qType = JSON.stringify({"q4Conf":{"_id":cId}})
    }else{
      qType = location;
    }
    question.fromPage = qType;

    if(_id) {
      QuestionActions.update(question, _id);
    } else {
      QuestionActions.create(question);
    }
  };

  static _handleCloseQuestionPopup() {
    QuestionActions.closeQuestionPopup();
  };

  _handleQuestionStore(state){
    this.setState({
      editQuestionPopup: state.editQuestionPopup
    });
  }

}

export default QuestionPopup;
